class PaginacaoListagemUtils {
	constructor(sortBy, rowsPerPage, direction) {
		this.rowsPerPage = rowsPerPage ? rowsPerPage : 5
		this.page = 1
		this.sortBy = [...sortBy]
		this.sortDesc = direction ? direction : []
	}
}


export default PaginacaoListagemUtils
